/* eslint-disable */
import React, { Component } from 'react';
import autoBind from 'react-autobind';

import navbarActions from '@common/store/navbar/navbar.actions';
import navbarSelectors from '@common/store/navbar/navbar.selectors';

import NavbarMenuAction from '@common/components/navbar/menu/navbar.menuAction';

import { connect } from '@common/components/base.component';

import { Menu } from 'antd';

class Sidemenu extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      showDrawer: false,
    };
  }

  onSelect({ item, key, keyPath, selectedKeys, domEvent }) {
    this.navigate(item.props.link);
  }

  renderMenuItem(item, key) {
    var newKey = !isNaN(key) ? item.name : `${key}-${item.name}`;
    if (item.menuItem) return this.renderSubMenu({ ...item, key: newKey });
    else
      return (
        <Menu.Item key={newKey} {...item}>
          <div style={{ width: '100%', display: 'flex', alignContent: 'space-between' }}>
            <div
              style={{ width: '90%' }}
              onClick={e => {
                if (item.idSistemaExterno) {
                  const isValidLink = link => /^(https?:\/\/)/.test(link);
                  if (isValidLink(item.link)) {
                    window.open(item.link, '_blank', 'noopener,noreferrer');                  
                    e.preventDefault();
                    e.stopPropagation();
                  }
                } else {
                  this.navigate(item.link);
                }
              }}
            >
              <span>{item.name}</span>
            </div>
            <div style={{ width: '10%' }}>
              <span>{item.add && <NavbarMenuAction type="add" link={item.add} />}</span>
            </div>
          </div>
        </Menu.Item>
      );
  }

  renderSubMenu(submenu) {
    const { name, menuItem, key } = submenu;
    return (
      <Menu.SubMenu
        key={key}
        title={
          <span>
            <span>{name}</span>
          </span>
        }
      >
        {menuItem.map((item) => this.renderMenuItem(item, key))}
      </Menu.SubMenu>
    );
  }

  navigate(link) {
    if (typeof window !== 'undefined') {
      window.location.href = link;
    }
  }

  hoverMenu(event) {
    //TODO: bug do menu ao passar o mouse em cima
    const { menuCollapse } = this.props.navbarSelectors;
    if (menuCollapse.locked) return;
    else this.props.navbarActions.toggleMenu();
  }

  render() {
    //nas novas versões do ANTD o novo menu  recebera a props items, melhorando a performance e diferenciando a forma de declarar menus e subMenus
    //com isso em todas as ações feitas no meu, se estoram erros no console, dificultando a visualização de novos bugs
    //devido a não ser o momento apropriado para troca do componente, pelos diversos projetos usando o mesmo, a linha de baixo foi adicionada para suprimir a mensagem de versão deprecated do menu
    //O MENU DEVE SER ATUALIZADO ASSIM QUE POSSIVEL
    console.log = console.warn = console.error = () => {};
    
    const { menu } = this.props.navbarSelectors;
    return (
      <Menu mode="vertical" theme="dark" onMouseOver={null}>
        {menu.map((item, index) => this.renderMenuItem(item, index))}
      </Menu>
    );
  }
}

export default connect({
  selectors: {
    navbarSelectors,
  },
  actions: {
    navbarActions,
  },
})(Sidemenu);
